import React from "react";
import { useAuth } from "../../../../context/authContext";
import { Wine } from "../../../../context/wineContext/reducer";
import { handleCopyEvents } from "../../../../lib/preventCopy";
import { createMarkup } from "../../../../utils/helper";

type TastingNoteProps = {
  bylineClassnames?: string;
  markupClassnames?: string;
  renderByline: boolean;
  review: Wine & {
    author?: string;
    review_date?: string;
  }
};

const TastingNote = ({ bylineClassnames, review, markupClassnames, renderByline }: TastingNoteProps) => {
  const { state: { user } } = useAuth();

  const {
    tasting_note,
    article_date,
    author,
    tasted_on,
  } = review;

  const bylineWithDate = React.useMemo(() => {
    if (tasted_on) {
      return tasted_on;
    } else {
      return article_date;
    }
  }, [tasted_on, article_date]);

  return (
    <div className={user?.role === 'publisher' || user?.is_user_pro ? "" : "nocopy"} onCopy={(e) => handleCopyEvents(e, user.role, user.is_user_pro)}>
      <p className={markupClassnames ?? "pb-2"} dangerouslySetInnerHTML={createMarkup(tasting_note)} />
      { renderByline && <p className={ bylineClassnames ?? "opacity-40 italic text-sm" }>- By { author }, { bylineWithDate }</p> }
    </div>
  )
}

export default TastingNote;
